import * as React from "react";
import { forwardRef } from "react";
const SvgIcMandatory12 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4.7125 6.60427L0 5.43235L0.675 3.29603L5.2375 5.13937L4.925 0H7.15L6.7875 5.21261L11.325 3.38149L12 5.55443L7.225 6.70193L10.425 10.6572L8.6 12L5.925 7.56867L3.275 11.8901L1.45 10.5961L4.7125 6.60427Z", fill: "#4FA4E7" }));
const ForwardRef = forwardRef(SvgIcMandatory12);
export { ForwardRef as ReactComponent };
